import { memo, useMemo } from "react";
import "./configcontent.scss";
import ConfigEmployees from "./Employees";
import { useSearchParams } from "../../../hook/use-search-params";
import ConfigSystemMgmt from "./SystemMgmt";
import ConfigDeleteAccountRequest from "./it-procedure/DeleteAccount";
import ConfigEPRRequest from "./it-procedure/EPR";
import ConfigITCodeGrantRequest from "./it-procedure/ITCodeGrant";
import ConfigRepairITToolRequest from "./it-procedure/RepairITTool";
import ConfigITToolGrantRequest from "./it-procedure/ITToolGrant";
import { ConfigPermission } from "./Permission";
import ConfigBusinessTicketRequest from "./company-office/BusinessTicket";
import ConfigSercurityControlCardRequest from "./company-office/SercurityControlCard";
import ConfigSercurityControlCardExternalRequest from "./company-office/SercurityControlCardExternal";
import ConfigBusniessVehicleCardRequest from "./company-office/BusinessVehicleCard";
import ConfigBusniessExternalCardRequest from "./company-office/BusinessVehicleCardExternal";
import ConfigBusinessVehicleRequest from "./company-office/BusinessVehicle";
import { configPermission } from "../../../constants/configPermission";
import { ForbiddenPage } from "../../../components/config-forbidden";
import ConfigAFLRequests from "./human-resource/afl-request";
import { ConfigId } from "../constanst/box-title";
import { useCheckPermission } from "./Permission/hooks/use-check-permission";

const ConfigContent = () => {
  const { searchParams } = useSearchParams();
  const configId = searchParams.get("configId") || "1";
  const isRead = useCheckPermission(configPermission.READ);
  const isCreate = useCheckPermission(configPermission.CREATE);
  const isUpdate = useCheckPermission(configPermission.UPDATE);
  const isDelete = useCheckPermission(configPermission.DELETE);
  const checkViewPermission = isRead || isCreate || isUpdate || isDelete;

  const Content: any = useMemo(() => {
    switch (configId) {
      case ConfigId.Employees:
        return ConfigEmployees;
      case ConfigId.SystemMgmt:
        return ConfigSystemMgmt;
      case ConfigId.DeleteAccountRequest:
        return ConfigDeleteAccountRequest;
      case ConfigId.EPRRequest:
        return ConfigEPRRequest;
      case ConfigId.ITCodeGrantRequest:
        return ConfigITCodeGrantRequest;
      case ConfigId.RepairITToolRequest:
        return ConfigRepairITToolRequest;
      case ConfigId.ITToolGrantRequest:
        return ConfigITToolGrantRequest;
      case ConfigId.BusinessTicketRequest:
        return ConfigBusinessTicketRequest;
      case ConfigId.SercurityControlCardRequest:
        return ConfigSercurityControlCardRequest;
      case ConfigId.SercurityControlCardExternalRequest:
        return ConfigSercurityControlCardExternalRequest;
      case ConfigId.BusinessVehicleRequest:
        return ConfigBusniessVehicleCardRequest;
      case ConfigId.BusniessExternalCardRequest:
        return ConfigBusniessExternalCardRequest;
      case ConfigId.BusniessVehicleCardRequest:
        return ConfigBusinessVehicleRequest;
      case ConfigId.Permission:
        return ConfigPermission;
      case ConfigId.AFLRequests:
        return ConfigAFLRequests;
      default:
        return ConfigEmployees;
    }
  }, [configId]);

  return checkViewPermission ? <Content /> : <ForbiddenPage />;
  // return <Content/>
};

export default memo(ConfigContent);
